import React from 'react';
import Card from '../Card';
import servicesData from '../../data/services-data';

export default () => (
  <section id="services" className="py-20 lg:pb-20 lg:pt-48">
    <div className="bg-primary py-12">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-semibold text-white">Services</h2>
        <p className="text-xl lg:text-2xl mt-6 font-light text-white">
          Accounting services tailored to your needs
        </p>
      </div>
    </div>
    <div className="container mx-auto text-center">
      <div className="flex flex-col flex-wrap sm:flex-row sm:-mx-3 mt-12">
        {servicesData.map(service => (
          <div key={service.slug} className="flex flex-1 md:flex-none md:w-1/3 px-3">
            <div className="flex text-black mb-8">
              <Card>
                <p className="font-semibold text-xl">{service.title}</p>
                <p className="mt-4">{service.landingSummary}</p>
              </Card>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
